module.exports = __webpack_public_path__ + "_/node_modules/@catalytic/pushbot-ui-xtras/assets/fonts/NotoSansUI-Bold.ttf?8132eb1c298deb8297aa3f344f9b3183]";


//////////////////
// WEBPACK FOOTER
// ../node_modules/@catalytic/pushbot-ui-xtras/assets/fonts/NotoSansUI-Bold.ttf
// module id = 1879
// module chunks = 32